
import { StoreApi } from 'zustand';
import { PriceState } from '../../types';
import { UserState } from '../../../auth/userSlice';
import { priceAlertService } from '@/services/priceAlerts/priceAlertService';
import { debugError } from '@/utils/debugLogger';

type GetPriceState = () => PriceState & UserState;
type SetPriceState = StoreApi<PriceState & UserState>["setState"];

export const deletePriceAlert = async (
  set: SetPriceState,
  get: GetPriceState,
  alertId: string
) => {
  try {
    const state = get();
    const { user, isAuthenticated } = state;
    
    if (!isAuthenticated || !user) {
      debugError('pricing', '[deletePriceAlert] Errore autenticazione', { 
        message: 'Utente non autenticato',
        isAuthenticated,
        hasUser: !!user
      });
      throw new Error('Utente non autenticato');
    }
    
    // Elimina dal database
    const success = await priceAlertService.deleteAlert(alertId, user.id);
    
    if (!success) {
      throw new Error('Impossibile eliminare l\'avviso dal database');
    }
    
    // Aggiorna lo store locale
    set((state: PriceState & UserState) => {
      const newAlerts = state.priceAlerts.filter(alert => 
        alert.id !== alertId || alert.userId !== user.id
      );
      
      return { priceAlerts: newAlerts };
    });
  } catch (error) {
    debugError('pricing', '[deletePriceAlert] Error deleting price alert', { 
      error: error instanceof Error ? error.message : String(error), 
      alertId,
      userId: get().user?.id 
    });
    throw error;
  }
};
